import { useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

import { useClickOutside } from '@/core/hooks/useClickOutside'
import { useAppSelector } from '@/core/store'
import { closeModal } from '@/core/store/ui.store'
import { formatPriceWithTwoDecimals } from '@/core/utils/numbers'

export function SpecialOffer() {
  const { modal, modalParams } = useAppSelector((store) => store.uiState)
  const [isLoading, setIsLoading] = useState(false)

  const dispatch = useDispatch()
  const ref = useRef(null)

  useClickOutside(ref, closeModalFn)

  function formatOldPrice(price: number | string): string {
    return formatPriceWithTwoDecimals(price)
  }

  function closeModalFn() {
    if (isLoading) return
    dispatch(closeModal())
  }

  async function buyNow(tour_id?: string) {
    if (tour_id === undefined) return

    setIsLoading(true)
    const unsuccessUrl = `${process.env.REACT_APP_WP_URL}/my-account/?referrer_tour=${tour_id}`

    try {
      const refresh_token = getCookie('WM_RefreshToken')
      const user_id = getCookie('WM_ID')

      const response = await fetch(
        `${process.env.REACT_APP_WP_URL}/wp-json/wm-subscription/v1/tours/new_from_webapp`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // Add other headers if needed (like authorization)
          },
          body: JSON.stringify({
            RefreshToken: refresh_token,
            ID: user_id,
            tourid: tour_id,
            token: process.env.REACT_APP_WP_TOKEN,
          }),
        },
      )

      if (!response.ok) {
        // throw new Error(`HTTP error! status: ${response.status}`)
        window.location.href = unsuccessUrl
      }

      const result = await response.json()
      if (result && result.url) window.location.href = result.url
      else window.location.href = unsuccessUrl
      setIsLoading(false)
      console.log(result)
    } catch {
      window.location.href = unsuccessUrl
      setIsLoading(false)
    }
  }

  return (
    <div className={'special__offer' + (modal === 'special__offer' ? ' active' : '')}>
      <div className="special__offer-modal" ref={ref}>
        <h4 className="special__offer-title">DEAL OF THE MONTH</h4>
        <p className="special__offer-header"> 50% discount for</p>
        <p className="special__offer-remark">
          In the Footsteps of Princess Ann (Roman Holiday) Tour
        </p>
        <p className="special__offer-header">
          {' '}
          Standard Price €{modalParams?.oldPrice ? formatOldPrice(modalParams.oldPrice) : ''}
        </p>
        <h5 className="special__offer-price">
          for just €{modalParams?.newPrice ? formatPriceWithTwoDecimals(modalParams.newPrice) : ''}
        </h5>
        <button className="special__offer-buy_now" onClick={() => buyNow(modalParams?.excursionId)}>
          Buy now <span>{'>'}</span>
          {isLoading ? <div className="custom-loader"></div> : null}
        </button>
      </div>
    </div>
  )
}

function getCookie(name: string) {
  const cookies = document.cookie.split('; ')
  for (const cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=')
    if (cookieName === name) {
      return decodeURIComponent(cookieValue)
    }
  }
  return null
}
